import {
  ENTITY_PROCEDURE_ASIDE_SECTION_ID,
  ENTITY_PROCEDURE_SECTION_ID,
} from '@/app/(main)/(pages)/_components/entities/entity-procedure/entity-procedure.const';

const SECTION_IDS = [ENTITY_PROCEDURE_SECTION_ID, ENTITY_PROCEDURE_ASIDE_SECTION_ID];

export function scrollToEntityProcedureSection(): void {
  const sections = SECTION_IDS
    .map((id) => document.getElementById(id))
    .filter((section): section is HTMLElement => section !== null);

  const target = sections.find((section) => section.offsetParent !== null) ?? sections[0];

  target?.scrollIntoView({ behavior: 'smooth' });
}
